declare namespace $ {

	type $mol_number__hint_bog_leaderboard_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_number__value_bog_leaderboard_2 = $mol_type_enforce<
		ReturnType< $bog_leaderboard['my_score'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $bog_leaderboard_row__place_bog_leaderboard_3 = $mol_type_enforce<
		ReturnType< $bog_leaderboard['row_place'] >
		,
		ReturnType< $bog_leaderboard_row['place'] >
	>
	type $bog_leaderboard_row__name_bog_leaderboard_4 = $mol_type_enforce<
		ReturnType< $bog_leaderboard['row_name'] >
		,
		ReturnType< $bog_leaderboard_row['name'] >
	>
	type $bog_leaderboard_row__score_bog_leaderboard_5 = $mol_type_enforce<
		ReturnType< $bog_leaderboard['row_score'] >
		,
		ReturnType< $bog_leaderboard_row['score'] >
	>
	type $mol_list__rows_bog_leaderboard_6 = $mol_type_enforce<
		ReturnType< $bog_leaderboard['board_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $bog_leaderboard extends $mol_page {
		Theme( ): $mol_theme_auto
		Lights( ): $mol_lights_toggle
		my_score( next?: number ): number
		Score_input( ): $mol_number
		row_place( id: any): string
		row_name( id: any): string
		row_score( id: any): string
		Row( id: any): $bog_leaderboard_row
		board_rows( ): readonly(any)[]
		Board( ): $mol_list
		title( ): string
		plugins( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
	type $mol_view__sub_bog_leaderboard_row_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_leaderboard_row_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_leaderboard_row_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_leaderboard_row extends $mol_view {
		place( ): string
		Place( ): $mol_view
		name( ): string
		Name( ): $mol_view
		score( ): string
		Score( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=leaderboard.view.tree.d.ts.map